export function digitsOnly(value) {
  return String(value ?? '').replace(/\D/g, '');
}

/** Local PK mobile: 03XX-XXXXXXX (no +92 / 92 prefix). */
export function maskPhone(value) {
  let digits = digitsOnly(value);
  if (digits.startsWith('92')) digits = digits.slice(2);
  if (digits.length === 10 && digits.startsWith('3')) digits = `0${digits}`;
  digits = digits.slice(0, 11);
  if (digits.length <= 4) return digits;
  return `${digits.slice(0, 4)}-${digits.slice(4)}`;
}

/** PK CNIC: XXXXX-XXXXXXX-X */
export function maskCnic(value) {
  const digits = digitsOnly(value).slice(0, 13);
  if (digits.length <= 5) return digits;
  if (digits.length <= 12) return `${digits.slice(0, 5)}-${digits.slice(5)}`;
  return `${digits.slice(0, 5)}-${digits.slice(5, 12)}-${digits.slice(12)}`;
}

export function isPhoneField(name) {
  return /^(mobile|phone)$/i.test(String(name || ''));
}

export function isCnicField(name) {
  return /^cnic$/i.test(String(name || ''));
}

export function maskFieldValue(name, value) {
  if (value == null || value === '') return value ?? '';
  if (isPhoneField(name)) return maskPhone(value);
  if (isCnicField(name)) return maskCnic(value);
  return value;
}
